import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0a3f0fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { style: {"max-width":"320px"} }

import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  setup(__props) {

const route = useRoute()

const code = computed(() => route.query.code)
const error = computed(() => route.query.error)
const message = computed(() => route.query.message)

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_svg_icon, {
      class: "mb-2",
      icon: "sad-cloud",
      "inherit-fill": true,
      height: "64"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(code.value) + " - " + _toDisplayString(error.value), 1),
      _createElementVNode("div", null, _toDisplayString(message.value), 1)
    ])
  ]))
}
}

})